module.exports = __webpack_public_path__ + "img/logo.bdad146c.png";